import { render, staticRenderFns } from "./ResearcherUniRequest.vue?vue&type=template&id=23ea698f&"
import script from "./ResearcherUniRequest.vue?vue&type=script&lang=js&"
export * from "./ResearcherUniRequest.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherUniRequest.vue?vue&type=style&index=0&id=23ea698f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports